export class ModalErrorEventType {

	static MODAL = {
		OK: 'OK',
		CANCEL: 'CANCEL',
		TRUE_MODAL: 'TRUE_MODAL',
		MODAL_CLOSE: 'MODAL_CLOSE'
	};

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/modal-error/modal-error.event.type.ts